/** Label i18n + classe de cor para o estado de um pedido (solicitação). */
export function estadoSolicitacao(status: string): { labelKey: string; classe: string } {
  switch (status) {
    case 'aberta': return { labelKey: 'requests.status.open', classe: 'bg-blue-100 text-blue-800' };
    case 'fechada': return { labelKey: 'requests.status.closed', classe: 'bg-green-100 text-green-800' };
    case 'cancelada': return { labelKey: 'requests.status.cancelled', classe: 'bg-muted text-muted-foreground' };
    default: return { labelKey: 'requests.status.open', classe: 'bg-muted text-muted-foreground' };
  }
}

/** Label i18n + classe de cor para o estado de um orçamento. */
export function estadoOrcamento(status: string): { labelKey: string; classe: string } {
  switch (status) {
    case 'enviado': return { labelKey: 'requests.quoteStatus.sent', classe: 'bg-blue-100 text-blue-800' };
    case 'aceito': return { labelKey: 'requests.quoteStatus.accepted', classe: 'bg-green-100 text-green-800' };
    case 'rejeitado': return { labelKey: 'requests.quoteStatus.rejected', classe: 'bg-muted text-muted-foreground' };
    default: return { labelKey: 'requests.quoteStatus.sent', classe: 'bg-muted text-muted-foreground' };
  }
}
